import i18n from "i18next";
import { initReactI18next } from "react-i18next";
//import LanguageDetector from "i18next-browser-languagedetector";
//import Backend from "i18next-http-backend";

// Translations for English and Persian
const resources = {
  en: {
    translation: {
      home: "Home",
      articles: "Articles",
      reserve: "Reserve",
      recentBlogs: "Recent Blogs",
      addBlog: "Add Blog",
      title: "Title",
      description: "Description",
      image: "Image",
      submit: "Submit",
      reset: "Reset",
      pleaseWriteTitle: "Please write a title",
    },
  },
  fa: {
    translation: {
      home: "خانه",
      articles: "مقالات",
      reserve: "رزرو",
      recentBlogs: "آخرین مقالات",
      addBlog: "افزودن مقاله",
      title: "عنوان",
      description: "توضیحات",
      image: "عکس",
      submit: "ثبت",
      reset: "حالت اولیه",
      pleaseWriteTitle: " عنوان وارد کنید",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "fa", // Set the default language to Persian
  fallbackLng: "fa", // Use Persian as fallback
  debug: true,
  interpolation: {
    escapeValue: false,
  },
  whitelist: ["fa"], // Limit to only Persian
});

export default i18n;
